export enum OffersEnum {
    'cart_overlay_offers_qualified' = 'qualifiedOffers',
    'cart_overlay_offers_not_qualified' = 'notQualifiedOffers',
    'cart_overlay_offers_in_cart' = 'inCartOffers',
    'manual_offers_in_cart' = 'appliedOffers'
}

export enum OffersComponentEnum {
    OffersLocation = 'offers',
    CartLocation = 'cart',
    showInCartOverlayPromotion = 'show_in_cart_overlay'
}

export enum OfferActionsEnum {
    apply = 'post',
    remove = 'delete'
}

export enum OfferTypesEnum {
    automatic = 'automatic',
    manual = 'manual'
}

export enum OfferMessagingType {
    error = 'error',
    success = 'success',
    threshold = 'threshold'
}
